export const countPathsNodes = [
  {
    id: "51.247.206.27",
    type: "custom",
    dragHandle: "noDrag",
    position: { x: 900, y: 300 },
    className: "server-plain non-draggable",
    data: { label: "51.247.206.27" },
  },
  {
    id: "102.80.143.201",
    type: "default",
    position: { x: 350, y: 100 },
    className: "gateway",
    data: { label: "102.80.143.201" },
    dragHandle: "noDrag",
  },
  {
    id: "10.5.112.134",
    type: "default",
    position: { x: 250, y: 415 },
    className: "gateway",
    data: { label: "10.5.112.134" },
    dragHandle: "noDrag",
  },
  {
    id: "71.20.12.201",
    type: "default",
    position: { x: 690, y: 190 },
    className: "gateway",
    data: { label: "71.20.12.201" },
    dragHandle: "noDrag",
  },
  {
    id: "135.156.222.108",
    type: "default",
    position: { x: 540, y: 500 },
    className: "gateway",
    data: { label: "135.156.222.108" },
    dragHandle: "noDrag",
  },
  {
    id: "194.200.5.136",
    type: "custom",
    position: { x: 85, y: 130 },
    className: "PC",
    data: { label: "194.200.5.136" },
    dragHandle: "noDrag",
  },
];
